import { NotebookSidebarPreference, NotebookType } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';

export const createNotebook = createAction('[Notebook] Create Notebook', props<{ reportToken: string }>());

/** any data type used because refering Angular js actions and API.type used */
export const addNotebookResourcesOnSuccess = createAction(
  '[Notebook] Add Notebook Resources on success',
  props<{ notebookResource: any }>()
);
export const addNotebookFailure = createAction('[Notebook] AddFailure', props<{ reportToken: string; error: Error }>());

export const updatePreference = createAction('UpdatePreference', props<{ params: NotebookSidebarPreference }>());

export const updateNotebookType = createAction(
  '[Notebook] Patch',
  props<{ notebookToken: string; notebookType: NotebookType }>()
);
